//import React from "react";
//import HeaderSection from "../components/my_journey/HeaderSection";
import SummitCarousel from "../components/my_journey/SummitCarousel";
import PersonalStory from "../components/my_journey/PersonalStory";
import Achievements from "../components/my_journey/Achievements";
import TrainingLifestyle from "../components/my_journey/TrainingLifestyle";
import KalonMission from "../components/my_journey/KalonMission";
import Footer from "../components/homepage/Footer";

export default function MyJourney() {
  return (
    <div className="w-full">
      <SummitCarousel />
      <PersonalStory />
      <Achievements />
      <TrainingLifestyle />
      <KalonMission />
      <Footer />
    </div>
  );
}
